import 'css-chunksrc/client/pages/projectPage/resourcesPage/groupsList/projectResourceSelect/styles.scss';export default {
  "icon": "_icon_a2s2p_1",
  "list": "_list_a2s2p_7"
};